import clsx from "clsx";
import { User } from "lucide-react";
import Image from "next/image";

import { useAuth } from "./AuthProvider";

function Avatar({ className }: { className?: string }) {
  const { user } = useAuth();
  const userAvatar = user?.user_metadata?.avatar_url;

  return (
    <div
      className={clsx(
        "inset-2 rounded-full overflow-hidden bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center",
        className
      )}
    >
      {userAvatar ? (
        <Image
          alt=""
          className="w-full h-full object-cover"
          height={48}
          src={userAvatar}
          unoptimized
          width={48}
        />
      ) : (
        <User aria-hidden="true" className="text-white font-semibold w-[1em] h-[1em]" />
      )}
    </div>
  );
}

export default Avatar;
